const l10n:FooterL10n =  {
  "linkList": {
    "companyLink": "Sobre nós",
    "termsOfService": "Termos de uso",
    "privacyPolicy": "Política de privacidade",
    "guaranteeOfRights": "Direitos do titular dos dados",
    "customerSupport": "SUPORTE",
    "cookiePolicy": "Política de cookies",
    "declarationOfSafety": "Segurança・Declaração de Segurança",
    "youthProtectionPolicy": "Política de proteção infantojuvenil",
    "communityPolicy": "Política da comunidade",
    "probability": "probability",
    "operationPolicy": "Política de operação",
    "doNotSell": "Não venda meus dados pessoais",
    "gameGrade": "게임이용등급",
    "communityPolicyView": "커뮤니티정책",
    "servicePolicy": "서비스정책",
    "termsOfUse": "회원정책",
    "operationPolicyNCJ": "운영방침",
    "reportRightsInfringement": "권리침해신고",
    "ncPrivacyCenter": "NC Privacy Center",
    "commercialTransactions": "특정상거래법에 의거한 표기",
    "settlementFund": "자금결제법에 따른 표시",
    "serviceTerm": "서비스 이용약관",
    "legalDocumentation": "Legal Documentation",
    "googleAPIDisclosure": "Google API Disclosure",
    "report": "신고하기",
    "serviceConsent": "Consentimento de Serviço da NC",
    "careers": "Careers",
    "termsOfMobile": "모바일게임 약관"
  },
  "footerWords": {
    "gameRelatedLaw": "Informações adicionais em acordo com as leis de videogames",
    "brandInformation": "Dados de nome empresarial",
    "copyright": "Direitos autorais",
    "channelingInfo": "A NC é uma agente de e-commerce que age como uma central dos jogos da PLAYNC. Ela não é, de forma alguma, uma agente comercial dos produtos supramencionados.<br>Todas as obrigações e responsabilidades associadas aos jogos centralizados estão a cargo dos terceiros de e-commerce individuais, e questões relacionadas a tal não são de nossa responsabilidade."
  },
  "infoCS": {
    "businessInformation": "Ver dados comerciais",
    "infoAddress": "Nome da empresa: NC Corporation, Co-CEO Kim Taek-Jin, Park Byung-Moo, Número de registro empresarial: 220-81-43000, E-commerce Registration: 2026-Seongnam Bundang A-0316",
    "infoAddressNCV": "9 RAFFLES PLACE #26-01 REPUBLIC PLAZA SINGAPORE (048619)",
    "mobile": "Endereço: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Coreia do Sul. SUPORTE ao cliente: +82 1600-0020. Fax: +82 02-2186-3550.",
    "pc": "Endereço: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Coreia do Sul. SUPORTE ao cliente: +82 1600-0020. Fax: +82 02-2186-3550.",
    "ncfamilyzone": "Endereço: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Coreia do Sul. SUPORTE ao cliente: +82 1600-0020. Fax: +82 02-2186-3550.",
    "other": "Endereço: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Coreia do Sul. SUPORTE ao cliente: +82 1600-0020. Fax: +82 02-2186-3550.",
    "none": "",
    "infoEmail": "E-mail",
    "infoEmail-mobile": "MobileCS@ncsoft.com",
    "infoEmail-pc": "credit@ncsoft.com",
    "infoEmail-ncfamilyzone": "ncfamilyzone@ncsoft.com",
    "infoEmail-other": "credit@ncsoft.com/(PC Game)/MobileCS@ncsoft.com/(Mobile Game)",
    "infoEmail-none": ""
  },
  "infoJP": {
    "jpTitle": "Título",
    "jpGenre": "Gênero",
    "jpPrice": "Preço",
    "jpPriceValue": "Gratuito para jogar (contém compras no jogo)",
    "jpOs": "Sistema operacional suportado",
    "jpPlatform": "Plataforma",
    "jpDevelopedBy": "Desenvolvedor/Distribuidora",
    "jpReleaseDay": "Data de lançamento",
    "jpReleaseDayValue_LW": "04 de novembro de 2021"
  },
  "country": {
    "KR": "Coreia do Sul",
    "TW": "Taiwan",
    "RU": "Rússia",
    "MY": "Malásia",
    "SA": "Arábia Saudita",
    "SG": "Singapura",
    "AE": "Emirados Árabes Unidos",
    "ID": "Indonésia",
    "JP": "Japão",
    "QA": "Catar",
    "TH": "Tailândia",
    "PH": "Filipinas",
    "HK": "Hong Kong",
    "UA": "Ucrânia",
    "BY": "Bielorrússia",
    "LT": "Lituânia",
    "PL": "Polônia",
    "GR": "Grécia",
    "IL": "Israel",
    "KW": "Kuwait",
    "AT": "Áustria",
    "US": "Estados Unidos da América",
    "CA": "Canadá",
    "DE": "Alemanha",
    "GB": "Reino Unido",
    "FR": "França",
    "BR": "Brasil",
    "IT": "Itália",
    "ES": "Espanha",
    "CL": "Chile",
    "NO": "Noruega",
    "SE": "Suécia",
    "IE": "Irlanda",
    "PT": "Portugal",
    "FI": "Finlândia",
    "DK": "Dinamarca",
    "CH": "Suíça",
    "AR": "Argentina",
    "PE": "Peru",
    "MX": "México",
    "KZ": "Cazaquistão",
    "UZ": "Uzbequistão",
    "AZ": "Azerbaijão",
    "GE": "Geórgia",
    "MD": "Moldávia",
    "AM": "Armênia",
    "MO": "Macau",
    "IN": "Índia",
    "PK": "Paquistão",
    "NL": "Países Baixos",
    "RO": "Romênia",
    "AU": "Austrália",
    "TR": "Turquia",
    "EC": "Equador",
    "CO": "Colômbia",
    "ZA": "África do Sul",
    "EG": "Egito",
    "NC": "Global"
  }
};

export default l10n;
